// Registro do que acontece na central para o painel interno /admin/metricas (api/evento.ts).
// Nada aqui pode atrapalhar o atendimento: falhou, segue sem registro e sem aviso.
import { estaEmbutido, origemDoSiteDeFora } from "./rotas";
import { chatDeLp } from "./whatsappDaPagina";

// "site" (www.suporte.com.br), "embed" (o "Ajuda" de um painel) ou "lp" (landing page), e o domínio de onde veio.
export const canalAtual = () =>
  estaEmbutido() ? { canal: chatDeLp() ? "lp" : "embed", painel: origemDoSiteDeFora() } : { canal: "site", painel: null };

export type TipoEvento = "resolveu" | "nao_resolveu" | "motivo" | "atendente" | "whatsapp";
export type MotivoNaoResolveu = "nao_entendi" | "mais_detalhes" | "duvida_outra";
export type OrigemAtendente = "rodape" | "cartao" | "insistencia" | "detalhar" | "sugerido";

interface Evento {
  tipo: TipoEvento;
  conversa: string;
  app: string; // slug do app na SAK
  registro?: number | null; // número da resposta, devolvido pela api/conversar
  detalhe?: MotivoNaoResolveu | OrigemAtendente;
  resumo?: string; // "whatsapp": o resumo do caso que foi na mensagem para o atendente
}

export const registrarEvento = (evento: Evento) => {
  try {
    fetch("/api/evento", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...evento, ...canalAtual() }),
      keepalive: true, // chega mesmo se a pessoa fechar a aba logo depois do clique
    }).catch(() => {});
  } catch {
    // sem registro
  }
};

// Plano B (a IA fora do ar, a SAK respondeu): grava a pergunta e devolve o número do registro,
// para o "Isso resolveu?" dessa resposta também entrar nas métricas. Espera no máximo 1,5 s.
export const registrarPerguntaSak = async (dados: {
  conversa: string;
  app: string;
  idioma: "pt" | "es";
  pergunta: string;
  resposta: string;
  semArtigo: boolean;
}): Promise<number | null> => {
  const limite = new AbortController();
  const timer = setTimeout(() => limite.abort(), 1500);
  try {
    const resposta = await fetch("/api/evento", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tipo: "pergunta_sak", ...dados, ...canalAtual() }),
      signal: limite.signal,
    });
    const json = await resposta.json();
    return typeof json?.registro === "number" ? json.registro : null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
};
